/* eslint-disable */

import axios from 'axios';



import { encryptStorage } from '../CustomStorage';
import { APP_CONSTANTS } from '../URLConstants';





const AudioCubeApiCallerInstance = axios.create({
    // .. where we make our configurations
  // baseURL: "https://cors-anywhere.herokuapp.com/"+ process.env.REACT_APP_SOUNDBOX_HOST_URL,
    baseURL:process.env.REACT_APP_SOUNDBOX_HOST_URL,
    cache: {
        maxAge: 10 * 60 * 1000, // Cache for 10 minutes
      },
    withCredentials: true,

});



AudioCubeApiCallerInstance.defaults.headers.common['Content-Type'] = 'application/json';
// AudioCubeApiCallerInstance.defaults.withCredentials = true

AudioCubeApiCallerInstance.interceptors.request.use(request => {

    if (process.env.REACT_APP_ENVIRONMENT === 'sandbox')
        request.headers["ngrok-skip-browser-warning"] = "69420"

    if(encryptStorage.getItem(APP_CONSTANTS.L_KEY_OF_USER_ADMIN_SSOTOKEN)!==null && encryptStorage.getItem(APP_CONSTANTS.L_KEY_OF_USER_ADMIN_SSOTOKEN)!==undefined)
     request.headers['Authorization']= `Bearer ${encryptStorage.getItem(APP_CONSTANTS.L_KEY_OF_USER_ADMIN_SSOTOKEN)}`


    return request;
}, error => {
    return Promise.reject(error);
});

AudioCubeApiCallerInstance.interceptors.response.use(response => {

    return response;
}, error => {
    if (error?.response?.status === 401){
        encryptStorage.setItem(APP_CONSTANTS.L_KEY_OF_USER_LOGGEDIN_STATUS, false);
        encryptStorage.setItem(APP_CONSTANTS.L_KEY_OF_USER_ADMIN_SSOTOKEN, null);
        encryptStorage.setItem(APP_CONSTANTS.L_KEY_OF_USER_DATA, null);
        window.location.reload();
    }
        
    return Promise.reject(error);
});

export default AudioCubeApiCallerInstance;